import { Metadata } from '@metaplex-foundation/mpl-token-metadata';
import { getAccountParsingFunction } from '../../../types/Account.mjs';

const parseMetadataAccount = getAccountParsingFunction(Metadata);

export { parseMetadataAccount };
//# sourceMappingURL=MetadataAccount.mjs.map
